export default __webpack_public_path__ + "static/media/deathschannel.f6e88698.png";